<res-info-panel *ngIf="showOwnInfoPanel" [i18nKey]="hisDynamicContent" [target]="target"></res-info-panel>
<ng-content select="[customStaticContent]"></ng-content>
<div class="layoutBlock">
    <div *ngIf="fullWidth; else columnHalf" class="columnFullWidth">
        <ng-template #dynamicFieldSetContainer></ng-template>
    </div>
    <ng-template #columnHalf>
        <ng-container *ngFor="let dynamicFieldSetContainer of dynamicTabChildCount">
            <div class="columnHalf">
                <ng-template #dynamicFieldSetContainer></ng-template>
            </div>
            <div class="columnHalf">
                <ng-template #dynamicFieldSetContainer></ng-template>
            </div> 
        </ng-container>
    </ng-template>
</div>
